import {safeLocalStorage} from './utils/safeLocalStorage.js';
import { config, mobileBreakPoint, user } from './utils.js';
import { onLoad } from './utils/onLoad';
import { delegateListener } from './utils/delegate-listener';
import { track } from './tracking/bi.js';
import { NotificationViewBIModel } from './BI/models';
import * as $ from 'jquery';

const notisfierUrl = config['notisfierUrl'];
const request = async (path, method) => {
    try {
        const response = await fetch(`${notisfierUrl}${path}`, {
            credentials: "include",
            mode: "cors",
            method: method || 'GET'
        });
        return response;
    } catch {
        return null;
    }
};
//pintar las notis en el contenedor indicado
const template = document.getElementById('notification-template')?.content;
const notificationsHeaderContainer = document.querySelector('.notifications-container');

onLoad(() => {
    if (!user) {
        safeLocalStorage.removeItem('notification-cache');
        return;
    }

    //Marcar todas las notis leidas
    delegateListener('click', 'button.js-notifications-read-all', async () => {
        safeLocalStorage.removeItem('notification-cache');
        await request('/api/inbox/', 'PATCH');
        window.location.reload();
    });

    delegateListener('click', '.notification-new', async e => {
        e.preventDefault();
        e.stopPropagation();
        const anchor = e.target.closest('a');
        await readNotification(anchor.dataset.inboxEntryId, anchor.dataset.communicationId, anchor.dataset.type, 'web');
        document.location = anchor.getAttribute('href');
    });
    delegateListener('auxclick', '.notification-new', e => {
        const anchor = e.target.closest('a');
        //como se abre en otro tab, le quitamos el new y no bloqueamos pq no hace falta
        anchor.querySelector('.notification-new').classList.remove('notification-new');
        readNotification(anchor.dataset.inboxEntryId, anchor.dataset.communicationId, anchor.dataset.type, 'web');
    });

    const toggles = document.querySelectorAll('.js-notifications-toggle');
    if (toggles.length) {
        //setear contador de notis sin leer
        loadHeaderNotifications();
        //listeners para mostrar/ocultar listado notis
        toggles.forEach(
            toggle => toggle.addEventListener('click', e => {
                e.preventDefault();
                e.stopPropagation();
                document.querySelector('header .notification-container').classList.toggle('show') && loadHeaderNotifications();

                //Mas codigo extra q no tengo claro q es pero lo copypasteo
                document.querySelector('header .user-menu').classList.remove('show');
                if ($(window).width() <= mobileBreakPoint) {
                    $('html, body').toggleClass('overflow-hidden', $('.notification-container').hasClass('show'));
                    $('body').toggleClass('position-relative', $('.notification-container').hasClass('show'));
                }
            })
        );
    }

    //Pagina de notificaciones
    if (config['page'] == 'Notifications') {
        const mainContainer = document.querySelector('.notification-wrapper');
        let nextUrl = '/api/inbox/?batchSize=15';
        new IntersectionObserver(
            async () => {
                if(!nextUrl) {
                    return;
                }
                const url = nextUrl;
                nextUrl = null;
        const response = await request(url);
        if (!response) {
            nextUrl = url;
            return;
        }
        const data = await response.json();
                renderNotifications(
                    data._embedded.entries,
                    mainContainer
                );
                nextUrl = data._links.next?.href;
                if(!document.querySelector('.notification-wrapper a')) {
                    document.querySelector('.notification-wrapper .empty-list').classList.remove('d-none');
                }
                if(!nextUrl) {
                    document.querySelector('#content-wrapper .spinner-grow').remove();
                }
            }
        ).observe(document.querySelector('#content-wrapper .spinner-grow'));
    }
});

const renderNotifications = (entries, container) => entries.forEach(inboxEntry => {
    if (template === undefined)
        return;
    const element = document.importNode(template, true);
    element.querySelector('a').setAttribute('href', inboxEntry.context.url);
    element.querySelector('a').dataset.inboxEntryId = inboxEntry.id;
    element.querySelector('a').dataset.communicationId = inboxEntry.communicationId;
    element.querySelector('a').dataset.type = inboxEntry.context.type || '';
    element.querySelector('.notification-title').textContent = inboxEntry.context.title;
    element.querySelector('.notification-text').textContent = inboxEntry.context.text;
    element.querySelector('.notification-row').classList.toggle('notification-new', !inboxEntry.readAt);
    const imgEl = element.querySelector('img');
    if (inboxEntry.context.image) {
        imgEl.setAttribute('src', inboxEntry.context.image);
    } else {
        imgEl.classList.add('invisible');
    }
    container.appendChild(element);
});

//Marcar como leidas: funcion y listeners
const readNotification = (inboxEntryId, communicationId, type, from) => {
    safeLocalStorage.removeItem('notification-cache');
    track( new NotificationViewBIModel(user.id, communicationId, type  || 'other', from) );
    if (inboxEntryId) {
        return request(`/api/inbox/${inboxEntryId}/`, 'PATCH');
    }
};

//Notifications en el header
const getCachedNotifications = async () => {
    let [timestamp, data] = JSON.parse(safeLocalStorage.getItem('notification-cache') || '[0,0]');
    if (timestamp + 60000 < Date.now()) {
        safeLocalStorage.setItem(
            'notification-cache',
            JSON.stringify(
                [
                    timestamp = Date.now(), 
                    data = await request('/api/inbox/?batchSize=5')
                        .then(response => response ? response.json() : { _embedded: { entries: [] }, unread: 0 })
                ] 
            )
        );
    }
    return data;
};

const loadHeaderNotifications = async () => {
    const data = await getCachedNotifications();
    if (!data._embedded)
        return;
    notificationsHeaderContainer.replaceChildren();
    renderNotifications(data._embedded.entries, notificationsHeaderContainer);
    document.querySelector('.js-notifications-toggle .counter').textContent = data.unread || ''
};


